import React, {Fragment, useState} from 'react';
import {connect} from "react-redux";
import SqftPopupWindow from "./popup/SqftPopupWindow";
import {FormattedMessage, injectIntl} from "react-intl";
import FeatureThumbnail from "../../visComponents/featureThumbnail";
import FeatureName from "../../visComponents/featureName";
import {getNavItems} from "../helpers/sqftHelperUi";
import {getSlabImagesAreaGrouped} from "../helpers/sqftCalculations";
import {getCountertopFeatureGroup, getCurrentLayout} from "../../appLayout";

const SqftFooterSlabInfo = () => {
  const [isOpened, setIsOpened] = useState(false)
  const handleClick = () => {
    setIsOpened(!isOpened)
  }
  const cancelCallback = () => {
    setIsOpened(!isOpened)
  }

  let featureGroup = getCountertopFeatureGroup(getCurrentLayout());
  let navItems = getNavItems(featureGroup, "", {}, true, true);

  const getContent = () => {
    return <ul className={"slab-total__list"}>
      {
        getTotalItems()
      }
    </ul>
  }

  const getTotalItems = () => {
    let croppedSlabImagesPrepared = [];
    croppedSlabImagesPrepared = getSlabImagesAreaGrouped();

    return croppedSlabImagesPrepared.map((preparedSlabImage) => {
      const feature = navItems.find(feature => feature.part.dbFeature.id === preparedSlabImage.featureId)
      if (!feature) {
        return
      }

      return getTotalItem(feature, preparedSlabImage)
    })
  }

  const getTotalItem = (feature, preparedSlabImage) => {
    return <li key={feature.part.dbFeature.id}
               className={"slab-total__item"}>
      <div className={"slab-total__image"}>
        <FeatureThumbnail feature={feature.part}/>
      </div>
      <div className={"slab-total__info"}>
        <div className="slab-total__info-name">
          <FeatureName feature={feature.part}/>
        </div>
        <div className="slab-total__info-total">
          <FormattedMessage id={"sqft.popup.slab.total"}/>: {preparedSlabImage.totalArea}
        </div>
      </div>
    </li>
  }

  return (
    <Fragment>
      <button className="info-hexagon" onClick={handleClick}>
        i
      </button>
      <SqftPopupWindow
        title={<FormattedMessage id={"sqft.footer.totalSlab"}/>}
        content={getContent()}
        isOpened={isOpened}
        confirmCallback={cancelCallback}
        confirmText={<FormattedMessage id={"sqft.popup.slab.continue"}/>}
        cancelCallback={cancelCallback}
        cancelText=""
      />
    </Fragment>
  )
};

const mapStateToProps = (state) => ({
  croppedSlabImages: state.sqftSlabState.croppedSlabImages,
});

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFooterSlabInfo)
);
